import React from 'react'

import { iconTextRow } from '@ui-kit/components/IconTextRow/styles'

import type { Props } from './types'

const IconTextRow = ({ icon, text, className }: Props) => {
  const { container, text: textSlot } = iconTextRow()
  return (
    <div className={container({ className })}>
      {icon}
      <span className={textSlot()}>{text}</span>
    </div>
  )
}

export default IconTextRow
